<div *ngIf="isActive" class="advisor-banner">
  <span>Estás viendo esta cuenta como asesor.</span>
  <button type="button" (click)="exit()">Buscar otro cliente</button>
</div>
